import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/24/solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuComponent',
  props: {
    menu: {
        type: Object,
        default: () => ({})
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(MenuButton), { class: "inline-flex items-center justify-center rounded-xl bg-primary-500 p-3 text-sm text-white" }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Actions ", -1)),
            _createVNode(_unref(ChevronDownIcon), {
              class: "ml-2 h-3 w-3",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-100 ease-out",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-in",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuItems), { class: "absolute right-0 z-50 mt-2 max-w-fit origin-top-right rounded-md bg-white shadow-lg border border-gray-300" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "",
                  key: i
                }, [
                  (i.allowed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_unref(MenuItem), {
                          onClick: ($event: any) => (_ctx.$emit('click-menu', i.name))
                        }, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("button", {
                              class: _normalizeClass([
                                active ? 'bg-gray-200' : 'text-gray-900',
                                'group flex w-full whitespace-nowrap items-center text-sm px-6 py-3',
                                ])
                            }, _toDisplayString(i.name), 3)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})